import { useEffect, useState } from "react";
import { ContractService } from "../../../../core/services/ContractService";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";

interface Props {
    contract: any;
}
export const InfoSecop = ({ contract }: Props) => {

    const contracService = new ContractService();
    const [info, setInfo] = useState<any>([]);


    useEffect(() => {
        contracService.getSecopInfoByContractCode(_single.getAccountID(), contract.InternalCode).subscribe(
            (resp: any) => {
                if (resp) {
                    // Ensure info is always an array
                    const dataArray = Array.isArray(resp.DataBeanProperties.ObjectValue) ? resp.DataBeanProperties.ObjectValue : [resp.DataBeanProperties.ObjectValue];
                    setInfo(dataArray);
                } else {
                    setInfo([]);
                }
            }
        )
    }, [contract])

    const formatCurrency = (value: any) => {
        const num = parseFloat(value);
        if (isNaN(num)) return value;
        return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(num);
    };

    const formatDate = (dateStr: string) => {
        if (!dateStr || dateStr === "Sin Descripcion") return "No definida";
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString('es-CO', { year: 'numeric', month: 'long', day: 'numeric' });
        } catch (e) {
            return dateStr;
        }
    };

    const renderSecopItem = (item: any) => {
        const data = item?.DataBeanProperties || item; // Handle both direct object or DataBean wrapped

        return (
            <div className="card shadow-sm mb-4 border-0" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                <div className="card-header  py-3">
                    <h5 className="mb-0">
                        <i className="ri-information-line me-2"></i>
                        Detalles SECOP - {data.referencia_del_contrato}
                    </h5>
                </div>
                <div className="card-body p-4">
                    {/* General Information */}
                    <div className="mb-4">
                        <h6 className="text-primary border-bottom pb-2 mb-3 fw-bold">Información General</h6>
                        <div className="row g-3">
                            <div className="col-md-12">
                                <label className="text-muted d-block small mb-1">Objeto del Contrato</label>
                                <p className="fw-medium">{data.objeto_del_contrato}</p>
                            </div>
                            <div className="col-md-4">
                                <label className="text-muted d-block small mb-1">Tipo de Contrato</label>
                                <span className="badge bg-soft-info text-info p-2">{data.tipo_de_contrato}</span>
                            </div>
                            <div className="col-md-4">
                                <label className="text-muted d-block small mb-1">Modalidad</label>
                                <p className="mb-0">{data.modalidad_de_contratacion}</p>
                            </div>
                            <div className="col-md-4">
                                <label className="text-muted d-block small mb-1">Ubicación</label>
                                <p className="mb-0"><i className="ri-map-pin-line me-1"></i>{data.ciudad}, {data.departamento}</p>
                            </div>
                        </div>
                    </div>

                    {/* Financial Values */}
                    <div className="mb-4">
                        <h6 className="text-primary border-bottom pb-2 mb-3 fw-bold">Valores y Ejecución</h6>
                        <div className="row g-3">
                            <div className="col-md-4">
                                <div className="p-3 bg-light rounded-3 text-center">
                                    <label className="text-muted d-block small mb-1">Valor Total</label>
                                    <h5 className="text-success mb-0 fw-bold">{formatCurrency(data.valor_del_contrato)}</h5>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="p-3 bg-light rounded-3 text-center">
                                    <label className="text-muted d-block small mb-1">Pendiente Ejecución</label>
                                    <h5 className="text-warning mb-0 fw-bold">{formatCurrency(data.valor_pendiente_de_ejecucion)}</h5>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="p-3 bg-light rounded-3 text-center">
                                    <label className="text-muted d-block small mb-1">Pendiente Pago</label>
                                    <h5 className="text-danger mb-0 fw-bold">{formatCurrency(data.valor_pendiente_de_pago)}</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Important Dates */}
                    <div className="mb-4">
                        <h6 className="text-primary border-bottom pb-2 mb-3 fw-bold">Cronograma</h6>
                        <div className="row g-3">
                            <div className="col-md-3 col-sm-6">
                                <label className="text-muted d-block small mb-1">Fecha Firma</label>
                                <p className="mb-0 fw-medium">{formatDate(data.fecha_de_firma)}</p>
                            </div>
                            <div className="col-md-3 col-sm-6">
                                <label className="text-muted d-block small mb-1">Inicio Contrato</label>
                                <p className="mb-0 fw-medium">{formatDate(data.fecha_de_inicio_del_contrato)}</p>
                            </div>
                            <div className="col-md-3 col-sm-6">
                                <label className="text-muted d-block small mb-1">Fin Contrato</label>
                                <p className="mb-0 fw-medium">{formatDate(data.fecha_de_fin_del_contrato)}</p>
                            </div>
                            <div className="col-md-3 col-sm-6">
                                <label className="text-muted d-block small mb-1">Última Actualización</label>
                                <p className="mb-0 fw-medium text-info">{formatDate(data.ultima_actualizacion)}</p>
                            </div>
                        </div>
                    </div>

                    {/* Entities and People */}
                    <div className="row g-3">
                        <div className="col-md-6">
                            <h6 className="text-primary border-bottom pb-2 mb-3 fw-bold">Contratista</h6>
                            <div className="p-3 border rounded-3 h-100">
                                <p className="mb-1 fw-bold">{data.proveedor_adjudicado}</p>
                                <p className="mb-0 small text-muted"><i className="ri-profile-line me-1"></i>{data.tipodocproveedor}: {data.documento_proveedor}</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <h6 className="text-primary border-bottom pb-2 mb-3 fw-bold">Representante Legal</h6>
                            <div className="p-3 border rounded-3 h-100">
                                <p className="mb-1 fw-bold">{data.nombre_representante_legal}</p>
                                <p className="mb-0 small text-muted"><i className="ri-shield-user-line me-1"></i>DNI: {data.identificaci_n_representante_legal}</p>
                            </div>
                        </div>
                    </div>

                    {/* External Link */}
                    <div className="mt-4 text-center">
                        <a href={data.urlproceso} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary px-4 rounded-pill mt-4">
                            <i className="ri-external-link-line me-2"></i> Ver proceso completo en SECOP II
                        </a>
                    </div>
                </div>
            </div>
        );
    };

    return (

        <div className="container-fluid py-2">
            {/* <PrintJson json={info} /> */}
            {!info || info.length === 0 ? (
                <div className="text-center p-5 bg-light rounded-3">
                    <i className="ri-search-eye-line display-4 text-muted"></i>
                    <p className="mt-2">Buscando información en SECOP...</p>
                </div>
            ) : (
                info.map((item: any, idx: number) => (
                    <div key={idx}>
                        {renderSecopItem(item)}
                    </div>
                ))
            )}
        </div>
    );
};